import { render, staticRenderFns } from "./VerifyDomainAvailability.vue?vue&type=template&id=fbc536b0&"
import script from "./VerifyDomainAvailability.vue?vue&type=script&lang=js&"
export * from "./VerifyDomainAvailability.vue?vue&type=script&lang=js&"
import style0 from "./VerifyDomainAvailability.vue?vue&type=style&index=0&id=fbc536b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports